import React from 'react'

const formatMenu = menuItems => {
  return menuItems.map((menuItem, menuIndex) => {
    // Menu item with sub links
    if (menuItem.items?.[0]?.dropdown_link?.url) {
      return {
        dropdown: true,
        label: menuItem.primary.label,
        link: <a href={menuItem.primary.link.url}>{menuItem.primary.label}</a>,
        subLinks: menuItem.items.map((subMenuItem, subMenuIndex) => {
          const url =
            subMenuItem?.dropdown_link.url ||
            subMenuItem?.dropdown_link?.document?.url
          const label =
            subMenuItem?.dropdown_label ||
            subMenuItem?.dropdown_link?.document?.data.title
          return (
            <a key={`menu-${menuIndex}-${subMenuIndex}`} href={url}>
              {label}
            </a>
          )
        }),
      }
    }

    // Top level menu item
    return (
      <a
        key={`menu-${menuIndex}`}
        href={menuItem?.primary?.anchor_link || menuItem?.primary?.link?.url}
      >
        {menuItem.primary.label}
      </a>
    )
  })
}
export default formatMenu
